module.exports = __webpack_public_path__ + "media/images/commercial_offers/logo_big-aa5da32109e131fad6460e9eb5ab8e76.png";